import produce from 'immer';
import { GET_PERMISSIONS_FAILURE, GET_PERMISSIONS_REQUEST, GET_PERMISSIONS_SUCCESS, CLEAR_PERMISSIONS, } from './constants';
export var getInitialState = function () { return ({
    appGroups: [],
    loading: false,
    permissions: {},
    permissionItems: [],
    targetPermissions: [],
    targetPermissionsNew: [],
    targetPermissionPatches: [],
    permissionAppGroups: [],
    permissionRoles: [],
    rolePermissions: [],
    rolePermissionsRoleId: '',
    rolePermissionPatches: [],
    error: false,
}); };
function appReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        var _a, _b;
        // due to eslint:no-case-declarations
        var existingPatchForGroup, existingPatchForGroupIdx;
        var existingPatchForTarget, existingPatchForTargetIdx;
        switch (action.type) {
            case GET_PERMISSIONS_REQUEST:
                state.loading = true;
                break;
            case GET_PERMISSIONS_SUCCESS: {
                state.loading = false;
                var permissions_1 = action.permissions || {};
                Object.keys(permissions_1).forEach(function (target) {
                    state.permissions[target] = permissions_1[target] || [];
                });
                break;
            }
            case GET_PERMISSIONS_FAILURE:
                state.loading = false;
                break;
            case CLEAR_PERMISSIONS:
                state.permissions = {};
                break;
            case 'PERMISSION_ITEMS_LOAD_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'PERMISSION_ITEMS_LOAD_SUCCESS':
                state.loading = false;
                state.permissionItems = action.permissionItems || [];
                break;
            case 'PERMISSION_ITEMS_LOAD_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'TARGET_PERMISSION_LOAD_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'TARGET_PERMISSION_LOAD_SUCCESS':
                state.loading = false;
                state.targetPermissions = action.targetPermissions || [];
                break;
            case 'TARGET_PERMISSION_LOAD_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'APP_GROUPS_LOAD_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'APP_GROUPS_LOAD_SUCCESS':
                state.appGroups = action.appGroups || [];
                state.loading = false;
                state.error = false;
                break;
            case 'APP_GROUPS_LOAD_FAILURE':
                state.appGroups = action.appGroups || [];
                state.loading = false;
                state.error = true;
                break;
            // When a permission checkbox in the table body is clicked
            case 'TARGET_PERMISSIONS_EDIT':
                // See if a patch object already exists for this Group in the list of patches
                existingPatchForGroupIdx = state.targetPermissionPatches.findIndex(function (patch) { return patch.groupId === action.groupId; });
                if (existingPatchForGroupIdx !== -1) {
                    // Patch object exists for group
                    existingPatchForGroup =
                        state.targetPermissionPatches[existingPatchForGroupIdx];
                    if (existingPatchForGroup[action.action]) {
                        // Patch action also exists: remove action from patch object (user has clicked the
                        // checkbox twice, needing to reverse the action from the patch)
                        delete existingPatchForGroup[action.action];
                        if (!('create' in existingPatchForGroup ||
                            'read' in existingPatchForGroup ||
                            'update' in existingPatchForGroup ||
                            'delete' in existingPatchForGroup ||
                            'permission' in existingPatchForGroup)) {
                            // If after this action is removed none of the 5 actions are defined on the patch object,
                            // then also remove patch object entirely from list of patches
                            state.targetPermissionPatches.splice(existingPatchForGroupIdx, 1);
                        }
                    }
                    else {
                        // Patch object exists, action doesn't exist. Set it.
                        existingPatchForGroup[action.action] = action.checked
                            ? 'grant'
                            : 'revoke';
                    }
                }
                else {
                    // Patch object for group doesn't exist, push patch object into list of patches
                    state.targetPermissionPatches.push((_a = {
                            groupId: action.groupId
                        },
                        _a[action.action] = action.checked ? 'grant' : 'revoke',
                        _a));
                }
                // Clean up values of variables shared between 2 cases
                existingPatchForGroup = undefined;
                existingPatchForGroupIdx = -1;
                break;
            // When a permission action header checkbox in the target permission table is clicked
            case 'TARGET_PERMISSIONS_MULTI_EDIT':
                // For each target permission, if group header is checked, set permission for the given action,
                // if header is unchecked, clear permission for the given action
                state.targetPermissions.forEach(function (perm) {
                    var _a, _b;
                    // See if a patch object already exists for this Group in the list of patches
                    existingPatchForGroupIdx = state.targetPermissionPatches.findIndex(function (patch) { return patch.groupId === perm.groupId; });
                    if (existingPatchForGroupIdx !== -1) {
                        // Patch object exists for group
                        existingPatchForGroup =
                            state.targetPermissionPatches[existingPatchForGroupIdx];
                        if (existingPatchForGroup[action.action]) {
                            // Patch action also exists
                            if (existingPatchForGroup[action.action] === 'revoke') {
                                // Patch action is revoke
                                if (action.checked) {
                                    // header is checked, delete patch action
                                    delete existingPatchForGroup[action.action];
                                }
                            }
                            else if (existingPatchForGroup[action.action] === 'grant') {
                                // Patch action is grant
                                if (!action.checked) {
                                    // header is unchecked, delete patch action
                                    delete existingPatchForGroup[action.action];
                                }
                            }
                            if (!('create' in existingPatchForGroup ||
                                'read' in existingPatchForGroup ||
                                'update' in existingPatchForGroup ||
                                'delete' in existingPatchForGroup ||
                                'permission' in existingPatchForGroup)) {
                                // If after this action is removed none of the 5 actions are defined on the patch object,
                                // then also remove patch object entirely from list of patches
                                state.targetPermissionPatches.splice(existingPatchForGroupIdx, 1);
                            }
                        }
                        else {
                            // Patch object exists, action doesn't exist. Set it.
                            existingPatchForGroup[action.action] = action.checked
                                ? 'grant'
                                : 'revoke';
                        }
                    }
                    else {
                        // Patch object for group doesn't exist, push patch object into list of patches
                        if (perm[action.action]) {
                            // Permission's action is true
                            if (!action.checked) {
                                // ..and header checkbox is un-checked, add a revoke patch
                                state.targetPermissionPatches.push((_a = {
                                        groupId: perm.groupId
                                    },
                                    _a[action.action] = 'revoke',
                                    _a));
                            }
                        }
                        else {
                            // Permission's action is false
                            if (action.checked) {
                                // ..and header checkbox is checked, add a grant patch
                                state.targetPermissionPatches.push((_b = {
                                        groupId: perm.groupId
                                    },
                                    _b[action.action] = 'grant',
                                    _b));
                            }
                        }
                    }
                });
                // Clean up values of variables shared between 2 cases
                existingPatchForGroup = undefined;
                existingPatchForGroupIdx = -1;
                break;
            // Add a new target permissions using the new target permission modal
            case 'TARGET_PERMISSION_ADD':
                state.targetPermissionsNew.push(action.newPerm);
                break;
            case 'TARGET_PERMISSIONS_UNDO':
                state.targetPermissionPatches = [];
                state.targetPermissionsNew = [];
                break;
            case 'TARGET_PERMISSIONS_PATCH_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'TARGET_PERMISSIONS_PATCH_SUCCESS':
                state.targetPermissions = action.targetPermissions || [];
                state.targetPermissionPatches = [];
                state.targetPermissionsNew = [];
                state.loading = false;
                state.error = false;
                break;
            case 'TARGET_PERMISSIONS_PATCH_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'PERMISSION_ROLES_LOAD_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'PERMISSION_ROLES_LOAD_SUCCESS':
                state.loading = false;
                state.permissionRoles = action.permissionRoles || [];
                break;
            case 'PERMISSION_ROLES_LOAD_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'ROLE_PERMISSIONS_LOAD_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'ROLE_PERMISSIONS_LOAD_SUCCESS':
                state.loading = false;
                state.rolePermissionsRoleId = action.roleId || '';
                state.rolePermissionPatches = [];
                state.rolePermissions = action.rolePermissions || [];
                break;
            case 'ROLE_PERMISSIONS_LOAD_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            // When a permission checkbox in the role permissions table body is clicked
            case 'ROLE_PERMISSIONS_EDIT':
                // See if a patch object already exists for this Target in the list of patches
                existingPatchForTargetIdx = state.rolePermissionPatches.findIndex(function (patch) {
                    return patch.target.scope === action.target.scope &&
                        patch.target.scopeId === action.target.scopeId &&
                        patch.target.name === action.target.name;
                });
                if (existingPatchForTargetIdx !== -1) {
                    // Patch object exists for target
                    existingPatchForTarget =
                        state.rolePermissionPatches[existingPatchForTargetIdx];
                    if (existingPatchForTarget[action.action]) {
                        // Patch action also exists: remove action from patch object (user has clicked the
                        // checkbox twice, needing to reverse the action from the patch)
                        delete existingPatchForTarget[action.action];
                        if (!('create' in existingPatchForTarget ||
                            'read' in existingPatchForTarget ||
                            'update' in existingPatchForTarget ||
                            'delete' in existingPatchForTarget ||
                            'permission' in existingPatchForTarget)) {
                            // If after this action is removed none of the 5 actions are defined on the patch object,
                            // then also remove patch object entirely from list of patches
                            state.rolePermissionPatches.splice(existingPatchForTargetIdx, 1);
                        }
                    }
                    else {
                        // Patch object exists, action doesn't exist. Set it.
                        existingPatchForTarget[action.action] = action.checked
                            ? 'grant'
                            : 'revoke';
                    }
                }
                else {
                    // Patch object for group doesn't exist, push patch object into list of patches
                    state.rolePermissionPatches.push((_b = {
                            target: action.target
                        },
                        _b[action.action] = action.checked ? 'grant' : 'revoke',
                        _b));
                }
                // Clean up values of variables shared between 2 cases
                existingPatchForTarget = undefined;
                existingPatchForTargetIdx = -1;
                break;
            // When a permission action header checkbox in the role permission table is clicked
            case 'ROLE_PERMISSIONS_MULTI_EDIT':
                // For each role permission, if group header is checked, set permission for the given action,
                // if header is unchecked, clear permission for the given action
                state.rolePermissions.forEach(function (perm) {
                    var _a, _b;
                    // See if a patch object already exists for this Target in the list of patches
                    existingPatchForTargetIdx = state.rolePermissionPatches.findIndex(function (patch) {
                        return patch.target.scope === perm.target.scope &&
                            patch.target.scopeId === perm.target.scopeId &&
                            patch.target.name === perm.target.name;
                    });
                    if (existingPatchForTargetIdx !== -1) {
                        // Patch object exists for group
                        existingPatchForTarget =
                            state.rolePermissionPatches[existingPatchForTargetIdx];
                        if (existingPatchForTarget[action.action]) {
                            // Patch action also exists
                            if (existingPatchForTarget[action.action] === 'revoke') {
                                // Patch action is revoke
                                if (action.checked) {
                                    // header is checked, delete patch action
                                    delete existingPatchForTarget[action.action];
                                }
                            }
                            else if (existingPatchForTarget[action.action] === 'grant') {
                                // Patch action is grant
                                if (!action.checked) {
                                    // header is unchecked, delete patch action
                                    delete existingPatchForTarget[action.action];
                                }
                            }
                            if (!('create' in existingPatchForTarget ||
                                'read' in existingPatchForTarget ||
                                'update' in existingPatchForTarget ||
                                'delete' in existingPatchForTarget ||
                                'permission' in existingPatchForTarget)) {
                                // If after this action is removed none of the 5 actions are defined on the patch object,
                                // then also remove patch object entirely from list of patches
                                state.rolePermissionPatches.splice(existingPatchForTargetIdx, 1);
                            }
                        }
                        else {
                            // Patch object exists, action doesn't exist. Set it.
                            existingPatchForTarget[action.action] = action.checked
                                ? 'grant'
                                : 'revoke';
                        }
                    }
                    else {
                        // Patch object for group doesn't exist, push patch object into list of patches
                        if (perm[action.action]) {
                            // Permission's action is true
                            if (!action.checked) {
                                // ..and header checkbox is un-checked, add a revoke patch
                                state.rolePermissionPatches.push((_a = {
                                        target: perm.target
                                    },
                                    _a[action.action] = 'revoke',
                                    _a));
                            }
                        }
                        else {
                            // Permission's action is false
                            if (action.checked) {
                                // ..and header checkbox is checked, add a grant patch
                                state.rolePermissionPatches.push((_b = {
                                        target: perm.target
                                    },
                                    _b[action.action] = 'grant',
                                    _b));
                            }
                        }
                    }
                });
                break;
            case 'ROLE_PERMISSIONS_UNDO':
                state.rolePermissionPatches = [];
                break;
            case 'ROLE_PERMISSIONS_PATCH_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'ROLE_PERMISSIONS_PATCH_SUCCESS':
                state.rolePermissions = action.rolePermissions || [];
                state.rolePermissionPatches = [];
                state.loading = false;
                state.error = false;
                break;
            case 'ROLE_PERMISSIONS_PATCH_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default appReducer;
